import { actions, services } from "@ehi/global-marketing-interface";

export const getTaxesPolicy = () => (dispatch) =>
    dispatch(
        actions.request({
            service: services.gma.content.taxes,
        })
    );